import { __module as a } from "./ghl-ui.es1665.js";
import { i as d } from "./ghl-ui.es1491.js";
import { f as p } from "./ghl-ui.es1666.js";
import { f as u } from "./ghl-ui.es1667.js";
import { f as v } from "./ghl-ui.es1668.js";
import { l as x } from "./ghl-ui.es1669.js";
import { m as _ } from "./ghl-ui.es1670.js";
(function(r, t) {
  var e = d.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var o = e(p), f = e(u), i = e(v), l = e(x), m = e(_), s = {
    code: "en-US",
    formatDistance: o.default,
    formatLong: f.default,
    formatRelative: i.default,
    localize: l.default,
    match: m.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, n = s;
  t.default = n, r.exports = t.default;
})(a, a.exports);
var h = a.exports;
export {
  h as e
};
